import styled from 'styled-components';

const PageStyles = styled.div``;

export default PageStyles;
